<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="p-2">
      <label
        for="address_1"
        class="block text-gray-700 mb-2 font-medium"
      >Address Line 1</label>
      <InputText
        id="address_1"
        :model-value="company.address?.address_1 || ''"
        :disabled="!isEditing"
        class="w-full"
        placeholder="Enter address line 1"
        @update:model-value="updateAddressField('address_1', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="address_2"
        class="block text-gray-700 mb-2 font-medium"
      >Address Line 2</label>
      <InputText
        id="address_2"
        :model-value="company.address?.address_2 || ''"
        :disabled="!isEditing"
        class="w-full"
        placeholder="Enter address line 2"
        @update:model-value="updateAddressField('address_2', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="city"
        class="block text-gray-700 mb-2 font-medium"
      >City</label>
      <InputText
        id="city"
        :model-value="company.address?.city || ''"
        :disabled="!isEditing"
        class="w-full"
        placeholder="Enter city"
        @update:model-value="updateAddressField('city', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="state"
        class="block text-gray-700 mb-2 font-medium"
      >State/County</label>
      <InputText
        id="state"
        :model-value="company.address?.state || ''"
        :disabled="!isEditing"
        class="w-full"
        placeholder="Enter state or county"
        @update:model-value="updateAddressField('state', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="postcode"
        class="block text-gray-700 mb-2 font-medium"
      >Postcode</label>
      <InputText
        id="postcode"
        :model-value="company.address?.postcode || ''"
        :disabled="!isEditing"
        class="w-full"
        placeholder="Enter postcode"
        @update:model-value="updateAddressField('postcode', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="country"
        class="block text-gray-700 mb-2 font-medium"
      >Country</label>
      <InputText
        id="country"
        :model-value="company.address?.country || ''"
        :disabled="!isEditing"
        class="w-full"
        placeholder="Enter country"
        @update:model-value="updateAddressField('country', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    company: {
        type: Object,
        required: true
    },
    isEditing: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:company']);

const updateAddressField = (field, value) => {
    const updatedCompany = { 
        ...props.company, 
        address: { 
            ...(props.company.address || {}), 
            [field]: value 
        } 
    };
    emit('update:company', updatedCompany);
};
</script> 